import { AuthService } from '../../../core/services/auth.service';
import { UserProfile } from '../../../core/models/user-profile.model';
import { LanguageService } from '../../../base/services/language.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';

import { LayoutMainComponent } from '../../pages/layout-main/layout-main.component';
import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { environment } from '@environment';

@Component({
  selector: 'app-layout-topbar',
  templateUrl: './layout-topbar.component.html',
  styleUrls: ['./layout-topbar.component.scss']
})
export class LayoutTopbarComponent implements OnInit, OnDestroy {

  // 事件觸發器 (EventEmitter)，透過 @Output() 這個裝飾器將它提供給外部引用
  @Output() sidebarToggled = new EventEmitter<void>();

  isUat: boolean = !environment.production;

  environmentLabel: string = environment.label;

  languages: MenuItem[]= [{
    id: 'btn-languages-en-us',
    label: 'English',
    command: () => {
      this.languageService.setLang('en-us');
    }
  },
  {
    id: 'btn-languages-zh-tw',
    label: '繁體中文',
    styleClass: 'bpaas-current-language',
    command: () => {
      this.languageService.setLang('zh-tw');
    }
  },
  {
    id: 'btn-languages-zh-cn',
    label: '简体中文',
    command: () => {
      this.languageService.setLang('zh-cn');
    }
  }];

  userMenus!: MenuItem[];

  userDisplay: string = '';

  private readonly _destroying$ = new Subject<void>();

  constructor(public layoutMain : LayoutMainComponent,
    private languageService: LanguageService,
    private translateService: TranslateService,
    private msalService: MsalService,
    private authService: AuthService) { }

  ngOnInit(): void {

    // 從 local storage 取出 user 基本資料, 主要是要取工號和名字
    const userProfile: UserProfile = this.authService.getUser();
    this.userDisplay = userProfile.username + ' ' + userProfile.firstname + ' ' + userProfile.lastname;

    this.userMenus = [
      {
        id: 'btn-logout',
        label: this.translateService.instant('menu.logout'),
        automationId: 'menu.logout',
        command: () => {
          this.msalService.logout();
        }
      }
    ];

    const currentLanguage = this.translateService.currentLang;
    this.setMenuItemHighlight(currentLanguage);

    this.translateService.onLangChange.pipe(
      takeUntil(this._destroying$)
    ).subscribe((event: LangChangeEvent) => {
      this.languageService.processMenuTranslation(this.userMenus);
      const currentLanguage = event.lang;
      this.setMenuItemHighlight(currentLanguage);
    });
  }

  /**
   * 根據當前語系變更語系下拉選單的顯示
   * @param currentLanguage
   */
  private setMenuItemHighlight(currentLanguage: string): void {
    this.languages.forEach(language => {
      if (language.id === `btn-languages-${currentLanguage}`) {
        language.styleClass = 'bpaas-menuitem-highlight';
      } else {
        language.styleClass = '';
      }
    });
  }

  // 切換 sidebar step 3 : 按下按鈕後發送一個事件
  toggleSidebar() {
    // 觸發 EventEmitter，it emits events when something happens. The parent binds to that event property and reacts to those events.
    console.log('LayoutTopbarComponent: topbar toggle sidebar button click, emit sidebarToggled event');
    this.sidebarToggled.emit();
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
